export function isBetaWaitlistEnabled(): boolean {
  return import.meta.env.VITE_BETA_WAITLIST_ENABLED === "true";
}

/** Signed-out Try/Join entrypoint. Unset/false/0 always fails closed. */
export function isPublicParticipationEnabled(): boolean {
  const value = import.meta.env.VITE_PUBLIC_PARTICIPATION_ENABLED as
    string | undefined;
  return value === "1" || value === "true";
}

/** Portable Transfer is rollout-gated independently in the API and PWA. */
export function isTransfersEnabled(): boolean {
  return import.meta.env.VITE_TRANSFERS_ENABLED === "true";
}

/** Opt-in discovery workspace; legacy Home remains the default. */
export function isDiscoveryWorkspaceEnabled(): boolean {
  const value = import.meta.env.VITE_DISCOVERY_WORKSPACE_ENABLED;
  return value === "true" || value === "1";
}

/**
 * Library rail in the Discover workspace (Explore apps / Your space /
 * Favorites / Import app). Off by default: the header's Discover/Library tabs
 * already cover navigation, and the rail's favorites shortcuts can wait until
 * they earn their place. Unset/false/0 always fails closed.
 */
export function isDiscoveryLibraryRailEnabled(): boolean {
  const value = import.meta.env.VITE_DISCOVERY_LIBRARY_RAIL_ENABLED;
  return value === "true" || value === "1";
}

/**
 * Home widgets (pinned surfaces + Add to Home). Off unless explicitly
 * enabled: unset/false/0 always fails closed.
 */
export function isWidgetsEnabled(): boolean {
  return import.meta.env.VITE_WIDGETS_ENABLED === "true";
}

export const DESKTOP_ONLY_ROUTES = new Set(["/runners"]);

/**
 * Unified route availability check used by App.tsx (direct-route gating),
 * GalleryHeader (nav filtering), and AccountShell (mainBleed/layout).
 * A desktop-only route is available only when desktop === true; every other
 * route is unconditionally available.
 */
export function isRouteAvailable(
  route: string,
  context: { desktop: boolean },
): boolean {
  if (DESKTOP_ONLY_ROUTES.has(route) && !context.desktop) return false;
  return true;
}
